import { useState } from 'react'

// Utils
import { useWindowSize } from 'hooks/usewindowsize'
import cn from 'clsx'
import styles from './licensepricing.css'

type TabsProps = {
  data: Array<Record<string, string>>
}

const Tabs = (props: TabsProps): JSX.Element => {
  const { data } = props

  const [selectedTab, setSelectedTab] = useState(0)
  const { width = 0 } = useWindowSize()

  return (
    <>
      <div className={styles.tabNav}>
        <a
          role="button"
          tabIndex={0}
          className={cn(selectedTab === 0 ? styles.tabTitleActive : styles.tabTitle)}
          onClick={() => setSelectedTab(0)}
        >
          {width < 425 ? 'Cat. C' : 'Category C'}
        </a>
        <a
          role="button"
          tabIndex={0}
          className={cn(selectedTab === 1 ? styles.tabTitleActive : styles.tabTitle)}
          onClick={() => setSelectedTab(1)}
        >
          {width < 425 ? 'Cat. B' : 'Category B'}
        </a>
        <a
          role="button"
          tabIndex={0}
          className={cn(selectedTab === 2 ? styles.tabTitleActive : styles.tabTitle)}
          onClick={() => setSelectedTab(2)}
        >
          {width < 425 ? 'Cat. A' : 'Category A'}
        </a>
        <a
          role="button"
          tabIndex={0}
          className={cn(selectedTab === 3 ? styles.tabTitleActive : styles.tabTitle)}
          onClick={() => setSelectedTab(3)}
        >
          Buy Down
        </a>
      </div>
      <div className={styles.tabContent}>
        <div className={styles.tabData}>
          <div>
            <strong>LICENSE FEE:</strong> {data[selectedTab].fee}
          </div>
          <div>
            <strong>&lt; 2 seconds:</strong> {data[selectedTab].sec2}
          </div>
          <div>
            <strong>&lt; 15 seconds:</strong> {data[selectedTab].sec15}
          </div>
          <div>
            <strong>&lt; 60 seconds:</strong> {data[selectedTab].sec60}
          </div>
        </div>
      </div>
    </>
  )
}

export default Tabs
